import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDashboardStats, getRecentOrders } from '../services/adminApi';
import DataTable from '../components/DataTable';
import StatusBadge from '../components/StatusBadge';

const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [s, r] = await Promise.all([getDashboardStats(), getRecentOrders()]);
      setStats(s);
      setRecent(r.data);
      setLoading(false);
    };
    load();
  }, []);

  if (loading) return <div className="admin-table-state">Loading dashboard…</div>;

  return (
    <div>
      <div className="page-head">
        <h1>Dashboard</h1>
      </div>

      {/* STAT CARDS */}
      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>Total Orders</h3>
          <div className="value">{stats.totalOrders}</div>
          <div className="change">{stats.pendingOrders} pending</div>
        </div>
        <div className="stat-card">
          <h3>Revenue (paid)</h3>
          <div className="value">{inr(stats.revenue)}</div>
        </div>
        <div className="stat-card">
          <h3>Customers</h3>
          <div className="value">{stats.totalUsers}</div>
        </div>
        <div className="stat-card">
          <h3>Active Products</h3>
          <div className="value">{stats.totalProducts}</div>
          <div className={`change ${stats.lowStock.length ? 'alert' : ''}`}>
            {stats.lowStock.length
              ? `${stats.lowStock.length} low on stock`
              : 'Stock healthy'}
          </div>
        </div>
      </div>

      {/* LOW STOCK ALERTS */}
      {stats.lowStock.length > 0 && (
        <div className="admin-section">
          <div className="section-head">
            <h2>⚠️ Stock Alerts</h2>
            <Link to="/admin/products" className="section-link">
              Manage products →
            </Link>
          </div>
          <div className="low-stock-list">
            {stats.lowStock.map((p) => (
              <div key={p.id} className="low-stock-item">
                <span className="low-stock-name">{p.name}</span>
                <StatusBadge
                  status={
                    Number(p.stock_quantity) === 0
                      ? 'Out of Stock'
                      : `${p.stock_quantity} left`
                  }
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* RECENT ORDERS */}
      <div className="admin-section">
        <div className="section-head">
          <h2>Recent Orders</h2>
          <Link to="/admin/orders" className="section-link">
            View all →
          </Link>
        </div>
        <DataTable
          columns={[
            { key: 'order_number', label: 'Order #' },
            { key: 'customer_name', label: 'Customer' },
            { key: 'customer_phone', label: 'Phone' },
            {
              key: 'final_amount',
              label: 'Amount',
              render: (o) => inr(o.final_amount),
            },
            {
              key: 'order_status',
              label: 'Status',
              render: (o) => <StatusBadge status={o.order_status} />,
            },
            {
              key: 'created_at',
              label: 'Date',
              render: (o) =>
                o.created_at
                  ? new Date(o.created_at).toLocaleDateString('en-IN', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })
                  : '—',
            },
          ]}
          rows={recent}
          emptyMessage="No orders yet — they'll appear here as customers buy."
        />
      </div>
    </div>
  );
}
